import React from 'react';
import { Growl } from 'primereact/growl';
import { useContextState } from 'core/context/main';
/**
 * [Component description]
 * Toaster
 * @category Component
 * @id [section]
 */
function Toaster() {
  const growl = React.useRef<Growl>(null);
  const notification = useContextState((state: any) => state.growl);

  React.useEffect(() => {
    if (notification) {
      growl.current!.show(notification);
    }
  }, [notification, growl]);

  return <Growl className="axpo-growl" ref={growl} />;
}

export default Toaster;
